var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5--\\u0421\\u041A--|---Web-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-02-02-\\u0421\\u041A-|-\\u0412-\\u0418\\u0441\\u043F\\u043E\\u043B\\u043D\\u0435\\u043D\\u0438\\u0438-|-\\u041E\\u043F\\u0440\\u0435\\u0434\\u0435\\u043B\\u043E\\u0442\\u044A-\\u0411\\u043E\\u043B\\u044C\\u043D\\u0438\\u0446\\u0443-|-\\u041E\\u0442\\u043F\\u0440\\u0430\\u0432\\u0438\\u0442\\u044C",
    transform: "translate(-860.000000, -29.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "header",
    fill: "#FFFFFF",
    transform: "translate(208.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "header-area",
    x: 0,
    y: 0,
    width: 1232,
    height: 80
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    fillOpacity: 0.3,
    fill: "#192233",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("rect", {
    id: "side-sheet",
    fill: "#FFFFFF",
    x: 820,
    y: 0,
    width: 620,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(820.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 620,
    height: 88
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/avatar/close",
    transform: "translate(40.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2576029,22.8711986 L16.1162791,22.0125224 C16.2880143,21.8407871 16.2880143,21.6118068 16.1162791,21.4400716 L10.7352415,16.0017889 L22.6994633,16.0017889 C22.9284436,16.0017889 23.1001789,15.8300537 23.1001789,15.6010733 L23.1001789,14.3989267 C23.1001789,14.1699463 22.9284436,13.9982111 22.6994633,13.9982111 L10.6779964,13.9982111 L16.059034,8.55992844 C16.2307692,8.3881932 16.2307692,8.15921288 16.059034,7.98747764 L15.2003578,7.12880143 C15.0286225,6.95706619 14.7996422,6.95706619 14.627907,7.12880143 L7.12880143,14.6851521 C6.95706619,14.8568873 6.95706619,15.0858676 7.12880143,15.2576029 L14.627907,22.8711986 C14.7996422,23.0429338 15.0858676,23.0429338 15.2576029,22.8711986 Z",
    id: "Icon",
    fill: "#192233"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.cd7dcd69.svg";
export { ForwardRef as ReactComponent };